// extracted by mini-css-extract-plugin
module.exports = {"component":"BlockButton-component--1ekx2"};